<template>
<span class="value-form-slug">
  {{value}}
  <a class="icon yule-icon-external-link" target="_blank" :href="url"></a>
</span>
</template>
<script>
import {formUrl} from '@/config/config'

export default {
  props: ['item', 'column', 'model'],
  data(){
    return{
      formUrl
    }
  },
  computed: {
    value(){
      return eval('this.item.' + this.column.name)
    },
    url(){
      return formUrl + 'form/' + this.value
    }
  }
}
</script>
<style lang="scss" scoped>
.yule-icon-external-link{
  text-decoration: none;
  font-size: 20px;
  margin-right: 5px;
  color: $grey;
}
</style>



// WEBPACK FOOTER //
// CollectionValueFormSlug.vue?36cae8e8